import { useQuery } from '@tanstack/react-query'
import { rqKeys } from '@/react-query-keys'
import { apiRequestNew } from '@/helpers/request'
import { getMs } from '@/helpers'
import type { T_DocsResponse } from '@/types/responses'

export const useDocumentContent = (categoryId?: string, docName?: string) => {
  const { data, isLoading } = useQuery<T_DocsResponse>({
    queryKey: [ rqKeys.documentContent, categoryId, docName ],
    queryFn: () =>
      apiRequestNew<T_DocsResponse>(
        'GET',
        `/portal/article?path=information/docs/${categoryId}&name=${docName}&fields=name,title,content`
      ),
    enabled: !!categoryId && !!docName,
    staleTime: getMs('15m'),
    refetchOnWindowFocus: false,
  })

  return { data, isLoading }
}